import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '../common/api';
import { APIEndPoints } from '../common/endPoint';

export const newMeeting = createAsyncThunk('newMeeting', async (body) => {
  const obj = {
    url: APIEndPoints.newMeeting,
    method: 'POST',
    body: JSON.stringify(body),
  };
  return await API(obj);
});
export const newGoogleMeeting = createAsyncThunk(
  'newGoogleMeeting',
  async (body) => {
    const obj = {
      url: APIEndPoints.GOOGLE_EVENT,
      method: 'POST',
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);
export const newOutlookMeeting = createAsyncThunk(
  'newOutlookMeeting',
  async (body) => {
    const obj = {
      url: APIEndPoints.OUTLOOK_EVENT,
      method: 'POST',
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const updateMeeting = createAsyncThunk('updateMeeting', async (body) => {
  const obj = {
    url: `${APIEndPoints.newMeeting}/${body.id}/update`,
    method: 'PUT',
    body: JSON.stringify(body),
  };
  return await API(obj);
});
export const updateGoogleMeeting = createAsyncThunk(
  'updateGoogleMeeting',
  async (body) => {
    const obj = {
      url: `${APIEndPoints.GOOGLE_EVENT}bridge${body.id}/`,
      method: 'PUT',
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);
export const updateOutlookMeeting = createAsyncThunk(
  'updateOutlookMeeting',
  async (body) => {
    const obj = {
      url: `${APIEndPoints.OUTLOOK_EVENT}/${body.id}/`,
      method: 'PATCH',
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const updateAttendeeStatus = createAsyncThunk(
  'updateAttendeeStatus',
  async (payload) => {
    const obj = {
      url: `${APIEndPoints.newMeeting}/${payload.meetingId}/attendee/${payload.id}/update`,
      method: 'PUT',
      body: JSON.stringify(payload),
    };
    return await API(obj);
  }
);

export const acceptProposedNewTime = createAsyncThunk(
  'acceptProposedNewTime',
  async (payload) => {
    const obj = {
      url: `${APIEndPoints.newMeeting}/${payload.meetingId}/proposal/${payload.attendeeId}/accept`,
      method: 'PUT',
      // body: JSON.stringify(payload.proposeNewTime),
    };
    return await API(obj);
  }
);

export const getEventDetail = createAsyncThunk(
  'getEventDetail',
  async (meetingId) => {
    const obj = {
      url: `${APIEndPoints.newMeeting}/${meetingId}`,
    };
    return await API(obj);
  }
);
export const getGoogleEventDetail = createAsyncThunk(
  'getGoogleEventDetail',
  async (meetingId) => {
    const obj = {
      url: `${APIEndPoints.GOOGLE_EVENT}/${meetingId}`,
    };
    return await API(obj);
  }
);
export const getOutlookEventDetail = createAsyncThunk(
  'getOutlookEventDetail',
  async (meetingId) => {
    const obj = {
      url: `${APIEndPoints.OUTLOOK_EVENT}/${meetingId}`,
    };
    return await API(obj);
  }
);

export const proposeNewTime = createAsyncThunk(
  'propseNewTime',
  async ({ meetingId, payload }) => {
    const obj = {
      url: `${APIEndPoints.proposeNewTime(meetingId)}`,
      method: 'PUT',
      body: JSON.stringify(payload),
    };
    return await API(obj);
  }
);

export const deleteMeeting = createAsyncThunk(
  'deleteMeeting',
  async (meetingId) => {
    const obj = {
      url: `${APIEndPoints.newMeeting}/${meetingId}`,
      method: 'DELETE',
    };
    return await API(obj);
  }
);
export const deleteGoogleMeeting = createAsyncThunk(
  'deleteGoogleMeeting',
  async (meetingId) => {
    const obj = {
      url: `${APIEndPoints.GOOGLE_EVENT}${meetingId}/`,
      method: 'DELETE',
    };
    return await API(obj);
  }
);
export const deleteOutlookMeeting = createAsyncThunk(
  'deleteOutlookMeeting',
  async (meetingId) => {
    const obj = {
      url: `${APIEndPoints.OUTLOOK_EVENT}${meetingId}`,
      method: 'DELETE',
    };
    return await API(obj);
  }
);

// export const generateMeetingId = createAsyncThunk(
//   'generateMeetingId',
//   async (meetingId) => {
//     const obj = {
//       url: `${APIEndPoints.meetingIDAPI}/generate_meeting_id`,
//       method: 'GET',
//     };
//     return await API(obj);
//   }
// );

export const generateMeetingId = createAsyncThunk(
  'generateMeetingId',
  async () => {
    const obj = {
      url: `${APIEndPoints.livekitMeetingIDAPI}`,
      method: 'POST',
    };
    return await API(obj);
  }
);

export const updateMeetingSecurity = createAsyncThunk(
  'updateMeetingSecurity',
  async (payload) => {
    const obj = {
      url: `${APIEndPoints.meetingIDAPI}/dynamic_meeting`,
      method: 'PUT',
      body: JSON.stringify(payload),
    };
    return await API(obj);
  }
);

export const updateLivekitMeeting = createAsyncThunk(
  'updateLivekitMeeting',
  async (payload) => {
    const obj = {
      url: `${APIEndPoints.livekitMeetingUpdate}`,
      method: 'PUT',
      body: JSON.stringify(payload),
    };
    return await API(obj);
  }
);

export const checkMeetingSecurity = createAsyncThunk(
  'checkMeetingSecurity',
  async (meetingId) => {
    const obj = {
      url: `${APIEndPoints.meetingIDAPI}/dynamic_meeting?meeting_id=${meetingId}`,
      method: 'GET',
    };
    return await API(obj);
  }
);

export const checkMeetingValidity = createAsyncThunk(
  'checkMeetingValidity',
  async (meetingId) => {
    const obj = {
      url: `${APIEndPoints.meetingIDAPI}/get_meetingid_info?meeting_id=${meetingId}`,
      method: 'GET',
    };
    return await API(obj);
  }
);

export const getMeetingDetailBySlug = createAsyncThunk(
  'getMeetingDetailBySlug',
  async (meetingSlug) => {
    const obj = {
      url: `${APIEndPoints.MeetingDetailBySlug(meetingSlug)}`,
      method: 'GET',
    };
    return await API(obj);
  }
);

export const getMeetingDetailByRoomId = createAsyncThunk(
  'getMeetingDetailByRoomId',
  async (roomId) => {
    const obj = {
      url: `${APIEndPoints.MeetingDetailByRoomId(roomId)}`,
      method: 'GET',
    };
    return await API(obj);
  }
);

// Waiting room: user notifies backend they want to join
export const joinMeetingWaitingRoom = createAsyncThunk(
  'joinMeetingWaitingRoom',
  async (payload) => {
    const obj = {
      url: `${APIEndPoints.WaitingRoomJoin}`,
      method: 'POST',
      body: JSON.stringify(payload),
    };
    return await API(obj);
  }
);


export const leaveMeetingWaitingRoom = createAsyncThunk(
  'leaveMeetingWaitingRoom',
  async (payload) => {
    const obj = {
      url: `${APIEndPoints.WaitingRoomLeave}`,
      method: 'POST',
      body: JSON.stringify(payload),
    };
    return await API(obj);
  }
);

// Waiting room: host fetches the list of users waiting to join
export const getWaitingRoomList = createAsyncThunk(
  'getWaitingRoomList',
  async (meetingSlug) => {
    const obj = {
      url: `${APIEndPoints.WaitingRoomList(meetingSlug)}`,
      method: 'GET',
    };
    return await API(obj);
  }
);

// Waiting room: host accepts or rejects a waiting participant
// action: 'accept' | 'reject' | 'accept_all'
export const waitingRoomAction = createAsyncThunk(
  'waitingRoomAction',
  async (payload) => {
    const obj = {
      url: `${APIEndPoints.WaitingRoomAction}`,
      method: 'POST',
      body: JSON.stringify(payload),
    };
    return await API(obj);
  }
);


export const getMeetingIdInfo = createAsyncThunk(
  'getMeetingIdInfo',
  async (meetingId) => {
    const obj = {
      url: `${APIEndPoints.meetingIDAPI}/get_meetingid_info`,
      method: 'POST',
      body: JSON.stringify({ meeting_id: meetingId }),
    };
    return await API(obj);
  }
);
export const deleteMeetingID = createAsyncThunk(
  'deleteMeetingID',
  async (payload) => {
    const obj = {
      url: `${APIEndPoints.meetingIDAPI}/dynamic_meeting`,
      method: 'DELETE',
      body: JSON.stringify(payload),
    };
    return await API(obj);
  }
);

export const deleteMeetingById = createAsyncThunk(
  'deleteMeetingById',
  async (meetingId) => {
    const obj = {
      url: `${APIEndPoints.meetingIDAPI}/${meetingId}`,
      method: 'DELETE'
    };
    return await API(obj);
  }
);

export const inviteUserToChat = createAsyncThunk(
  'inviteUserToChat',
  async (body) => {
    const obj = {
      url: APIEndPoints.InviteUser,
      method: 'POST',
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const sendMeetingRecordInformation = createAsyncThunk(
  'sendMeetingRecordInformation',
  async (body) => {
    const obj = {
      url: APIEndPoints.RecordingAPI,
      method: 'POST',
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const getMeetingRecordings = createAsyncThunk(
  'getMeetingRecordings',
  async (body) => {
    const obj = {
      url: `${APIEndPoints.RecordingAPI}?page=1&page_size=10`,
    };
    return await API(obj);
  }
);

export const deleteRecordings = createAsyncThunk(
  'deleteRecordings',
  async (id) => {
    const obj = {
      url: `${APIEndPoints.DeleteRecordingAPI(id)}`,
      method: 'DELETE',
    };
    return await API(obj);
  }
);

// export const deleteRecordings = createAsyncThunk(
//   'deleteRecordings',
//   async (id) => {
//     const obj = {
//       url: APIEndPoints.DownloadRecording({ recording_id: id, is_downloaded: true }),
//       method: 'GET',
//     };
//     return await API(obj);
//   }
// );

export const downloadRecording = createAsyncThunk(
  'downloadRecording',
  async ({ recording_id, is_downloaded = false }) => {
    const obj = {
      url: APIEndPoints.DownloadRecording({ recording_id, is_downloaded }),
      method: 'GET',
    };
    return await API(obj);
  }
);

export const downloadRecordingBlob = createAsyncThunk(
  'downloadRecordingBlob',
  async ({ recording_id, is_downloaded = false }) => {
    const obj = {
      url: APIEndPoints.DownloadRecording({ recording_id, is_downloaded }),
      method: 'GET',
      isResponseJSON: false,
    };
    return await API(obj);
  }
);

export const startRecording = createAsyncThunk(
  'startRecording',
  async (body) => {
    const obj = {
      url: APIEndPoints.StartRecording,
      method: 'POST',
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const stopRecording = createAsyncThunk(
  'stopRecording',
  async (body) => {
    const obj = {
      url: APIEndPoints.StopRecording,
      method: 'POST',
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const reportMeeting = createAsyncThunk(
  'reportMeeting',
  async (body) => {
    const obj = {
      url: APIEndPoints.ReportMeeting,
      method: 'POST',
      body: JSON.stringify(body),
    };
    return await API(obj);
  }
);

export const getGoogleMeetingDetails = createAction('getGoogleMeetingDetails');
export const updateUserNavStatus = createAction('updateUserNavStatus');
export const setMeetNow = createAction('setMeetNow');
export const setJoinMeetNow = createAction('setJoinMeetNow');
export const joinedUsersMeeting = createAction('joinedUsersMeeting');
export const joinMeeting = createAction('joinMeeting');
export const joinAMeeting = createAction('joinAMeeting');
export const joinEventMeeting = createAction('joinEventMeeting');
export const clearJoinedMeetingData = createAction('clearJoinedMeetingData');
export const startDefaultMeeting = createAction('startDefaultMeeting');
export const setShowChat = createAction('setShowChat');
export const clearShowChat = createAction('clearShowChat');
export const setShowMeet = createAction('setShowMeet');
export const clearShowMeet = createAction('clearShowMeet');
export const isMeetingRunning = createAction('isMeetingRunning');
export const clearMeetingRunning = createAction('clearMeetingRunning');
export const setMeetingWindowed = createAction('setMeetingWindowed');
export const clearMeetingWindowed = createAction('clearMeetingWindowed');
export const scheduleMeetingWithUser = createAction('scheduleMeetingWithUser');
export const clearScheduleMeetingWithUser = createAction('clearScheduleMeetingWithUser');
export const setPendingMeetingMessage = createAction('setPendingMeetingMessage')
export const meetingStarted = createAction('meetingStarted');